import React, {useRef, useEffect} from "react";
import Header from "../components/Header";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import mapboxgl from 'mapbox-gl'

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../components/Footer";

let img1 = require("../assets/home/funghi.jpg");
let img2 = require("../assets/home/ricerca-funghi-porcini.webp");
let video = require("../assets/home/video_home_1.mp4");

function Home() {
    const mapRef = useRef()
    const mapContainerRef = useRef()
    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoiZ2VvdGlja2V0c3JsIiwiYSI6ImNsenFvcmh1dzF0bDgyanFyd3lhaGhtNWMifQ.Lt-gOko0rO-VuTBu3kKD1w'
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            center: [12.2558141, 41.9097306],
            zoom: 5
        });

        return () => {
            mapRef.current.remove()
        }
    }, [])

    function renderCardsBlog() {
        let result = [];

        for (let i = 0; i < 4; i++) {
            result.push(<Col xs={12} md={3} className="p-2">
                <div className="card ">
                    <img className="card-img-top" src={img1} alt="Card image cap"/>
                    <div className="card-body">
                        <p className="card-text">Funghi velenosi: sintomi, consigli e cosa devi sapere</p>
                        <a href="#" className="btn btn-success">Leggi</a>
                    </div>
                </div>
            </Col>);
        }
        return result;
    }


    function renderCardsVideo() {
        let result = [];

        for (let i = 0; i < 4; i++) {
            result.push(<Col xs={12} md={3} className="p-2">
                <div className="video-community ">
                    <video autoPlay loop muted>
                        <source src={require("../assets/home/video_home_1.mp4")} type="video/mp4"/>
                        Il tuo browser non supporta il video.
                    </video>
                </div>
            </Col>);
        }
        return result;
    }

    function renderCardsTickets() {
        let result = [];

        for (let i = 0; i < 4; i++) {
            result.push(<Col xs={12} md={3} className="p-2">
                <div className="card card-ticket">
                    <img className="card-img-top" src={img1} alt="Card image cap"/>
                    <div className="card-body ">
                        <span>Funghi - Annuale</span><br/>
                        <span>Comunita' Montana di Valle Camonica</span><br/>
                        <span>Piazza Tassara Lombardia, Italia</span><br/>
                        <span>Tutti</span><br/>
                        <span>01/01/2024 - 31/12/2024</span><br/>
                        <span>80.00€</span><br/>
                        <div className={"mx-auto"}>
                            <a href="#" className="btn btn-success">Acquista</a>
                        </div>
                    </div>
                </div>
            </Col>);
        }
        return result;
    }

    return (
        <div style={{backgroundColor: "#212121"}}>
            <Header/>

            <div className="video-section">
                <video autoPlay loop muted className="background-video">
                    <source src={require("../assets/home/video_home_1.mp4")} type="video/mp4"/>
                    Il tuo browser non supporta il video.
                </video>

                {/* Sovrapposizione di pulsanti */}
                <div className="overlay-content">
                    <div style={{flex: 1}}>
                        <h1 className="title">Se vai a funghi, sei nel posto giusto</h1>
                    </div>
                    <div className="buttons">
                        <Button variant="success" className={"btn-bg-black"}>Tabella crescita funghi</Button>
                        <Button variant="success" className={"btn-bg-black"}>Acquista permessi</Button>
                        <Button variant="success" className={"btn-bg-black"}>Prenota esperienze</Button>
                    </div>
                </div>
            </div>
            <div className={"container-promo"}>
                <div style={{backgroundImage: `url(${img1})`}} className="background-container">
                    <h4>Tabella crescita funghi</h4>
                    <span>Scopri dove stanno nascendo i funghi in tempo reale</span>
                </div>
                <div style={{backgroundImage: `url(${img2})`}} className="background-container">
                    <h4>Geoticket experience</h4>
                    <span>Regala o prenota le migliori esperienze all'aperto d'Italia</span>
                </div>
            </div>

            <div className={"container m-4 d-flex justify-content-center align-items-center flex-column mx-auto"}>
                <Button variant="success" className={"btn-bg-black mb-4"}>ACQUISTA IL TUO PERMESSO</Button>

                <div>
                    <p>Sei indeciso? ecco alcuni suggerimenti per te...</p>
                </div>
                <Row>
                    {renderCardsTickets()}
                </Row>
                <Button variant="success" className={"btn-bg-black"}>CERCA ALTRI PERMESSI</Button>
            </div>
            <div style={{width: '100%', height: 420, position: 'relative'}}>
                <div id='map-container' className={"map"} ref={mapContainerRef}/>
                <div className="map-overlay">
                    <h4>scopri dove stanno nascendo</h4>
                    <span>La nostra mappa intelligente incrocia milioni di dati ambientali per prevedere le prossime nascite. <br/>Provala subito!</span>
                </div>
            </div>
            <div className={"container m-4 mx-auto"}>
                <div className="d-flex justify-content-center align-items-center flex-column">
                    <h4><b>ENTRA NELLA NOSTRA COMMUNITY</b></h4>
                    <p>Condividi con noi i tuoi video: li pubblicheremo sui nostri canali!</p>
                </div>
                <Row>
                    {renderCardsVideo()}
                </Row>
                <div className="d-flex justify-content-center align-items-center m-3">
                    <Button variant="success" className={"btn-bg-black"}>GUARDA I VIDEO</Button>
                </div>
            </div>

            <div className={"container-promo"}>
                <div style={{backgroundImage: `url(${img1})`}} className="background-container align-items-end ">
                    <h4>REGALATI UN'ESPERIENZA ALL'APERTO</h4>
                    <span style={{textAlign: "right"}}>Abbiamo selezionato per te le migliori esperienze di raccolta funghi in Italia. <br/>Regala, o prenota subito, la tua prossima avventura!</span>
                    <Button variant="success" className={"btn-bg-black"}>Regala o prenota</Button>

                </div>
            </div>
            <div className={"container m-4 mx-auto"}>
                <div className="d-flex justify-content-center align-items-center">
                    <h4><b>TRUCCHI E CONSIGLI PER CHI RACCOGLIE FUNGHI</b></h4>
                </div>
                <Row>
                    {renderCardsBlog()}
                </Row>
                <div className="d-flex justify-content-center align-items-center m-3">

                    <Button variant="success" className={"btn-bg-black"}>Scopri di più</Button>
                </div>
            </div>
            <div className={"container m-4 d-flex justify-content-center align-items-center mx-auto"}>
                <h4><b>DIVENTA PARTNER</b></h4>
            </div>
            <div className={"container-promo"}>
                <div style={{backgroundImage: `url(${img1})`}} className="background-container">
                    <h4>GESTISCI UN ENTE?</h4>
                    <span>Vendi i tuoi permessi e ticket con un click, con il nostro sistema completamente automatizzato</span>
                </div>
                <div style={{backgroundImage: `url(${img2})`}} className="background-container">
                    <h4>HAI UN LOCALE O NEGOZIO?</h4>
                    <span>Scopri come vendere permessi e ticket direttamente ai tuoi clienti</span>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Home;